module.exports = __webpack_public_path__ + "479f8ab7af0f4ed1364bcc917e9e4654.svg";